<template>
  <span>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <span v-if="(tratamiento.promocion === null || tratamiento.promocion === undefined)  && lista.length > 0 && esModalAplicarValido()" :id="'popover-promociones'+tratamiento.idPtiTratamiento" @click="visualizar()" href="#" tabindex="0">
      <em v-b-tooltip.right
          title="Este tratamiento tiene promoción" class="zoom pulsate-fwd fa fa-solid fa-tag" />
    </span>
    <div v-if="mostrar" style="overflow-scrolling: auto">
      <div v-for="(item,i) in lista" :key="'p'+i">
        <div class="bordePromo col-10 centrado"  v-if="!item.promocionReestringida">
           <p class="centrado">{{item.promocion}}
             <span v-if="item.descuento>0">({{item.descuento}}%)</span>
             <span v-else>(${{item.promoDescPesos}})</span>
           </p>
          <div class="col-2 text-right" v-if="!item.promocionReestringida">
           <b-button v-b-tooltip.hover title="Agregar promoción" size="sm" variant="ligth-primary" @click="agregarPromocion(item)">
             <em class="fa fa-plus-circle"></em>
           </b-button>
        </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>

export default {
  name: "TagPromocion",
  props: {
    promociones: Array,
    tratamiento: Object,
    idEtapa: Number,
    totalFinal : Number
  },
  data(){
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      mostrar: false,
      aux:[],
      aux1:[]
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods:{
    agregarPromocion(item){
      this.tratamiento.promocion = JSON.parse(JSON.stringify(item))
      item.seleccionado = true;
      item.tratmientosDescuento.forEach(f=>{

        if(f.idTratamiento == this.tratamiento.idTratamiento) {
          this.tratamiento.promocion.descuento = f.descuento;
          this.aplicarDescuentoActualizarTotal(f);
        }
      })
    },
    visualizar(){
      this.mostrar = !this.mostrar
    },
    aplicarDescuentoActualizarTotal(f){
      if(this.idEtapa === 61 || this.idEtapa === 65 || this.idEtapa === 64 || this.idEtapa === 79){
        let restar = 0;
        if (f.descuento > 0) {
          restar = (this.tratamiento.inversionFinal*f.descuento)/100;
          this.tratamiento.inversionFinal =  Math.round(this.tratamiento.inversionFinal - restar);
        } else {
          restar =f.promoDescPesos;
        }
        this.totalFinal = this.totalFinal - restar;
        this.$emit('restarPromocionAplicada',this.totalFinal);
      }
    },
    noAplicaPromoPlan(promoTmp) {
      //INICIO validamos la parte de si aplica al plan
      // const promoReal = this.promociones.find( value =>
      //     value.tratmientosDescuento.some( it => it['idTratamiento'] === this.tratamiento.idTratamiento)
      //     && value.idPromocion == promoTmp.idPromocion);

      //console.info("INICIO++++++++++++PROMO DE PLAN", promoTmp.aplicaEnPlanes);
      if (promoTmp.aplicaEnPlanes != null) { //Entra siempre y cuando la promocion este segmentada por regla de plan por ejemplo el descuento ( >= ) 10.
        if (this.tratamiento != null) {
          return this.calculosPromocionPlan(promoTmp, this.tratamiento);
        }
      }

      return false;
    },
    esModalAplicarValido() {
      const list = this.lista;
      return list.some(l=>!l.promocionReestringida);
    },
    calculosPromocionPlan(promoTmp, tratAct){
      let respuestaValSeg= true;
      let respuesta = false;
      let planesPromo = [];
      if (tratAct != null) {
        planesPromo =  promoTmp.aplicaEnPlanes[0];//obtengo regla de promocion por plan
        if(planesPromo !== undefined && planesPromo.operadorReglaPorAplicacionPlan != undefined && tratAct.porcentajePlanDescuento > 0){
          // la validacion de segmentacion por regla;
          respuestaValSeg = this.validarSegmentacionPlan(tratAct.porcentajePlanDescuento, planesPromo.operadorReglaPorAplicacionPlan, planesPromo.valorReglaPorAplicacionPlan);
        }
        const reglasTipoPac = [];

        if(promoTmp.pacienteNatural) {
          reglasTipoPac["pacienteNatural"] = promoTmp.pacienteNatural && tratAct.idTipoPaciente === 1;
        }
        if(!promoTmp.pacientePlan) {
          reglasTipoPac["pacientePlan"] = promoTmp.pacientePlan && tratAct.idTipoPaciente === 2;
        }

        const reglasSubTipoPac = [];

        if(promoTmp.pacienteNuevo) {
          reglasSubTipoPac["pacienteNuevo"] = promoTmp.pacienteNuevo && tratAct.idSubTipoPaciente === 1;
        }
        if(promoTmp.pacienteRecurrente) {
          reglasSubTipoPac["pacienteRecurrente"] = promoTmp.pacienteRecurrente && tratAct.idSubTipoPaciente === 2;
        }
        if(promoTmp.pacienteNA) {
          reglasSubTipoPac["pacienteNA"] = promoTmp.pacienteNA && tratAct.idSubTipoPaciente === 4;
        }

        const validoReglasTipoPac = reglasTipoPac.length == 0 || reglasTipoPac.some(t=>t);
        const validoReglasSubTipoPac = reglasTipoPac.length == 0 || reglasSubTipoPac.some(t=>t);
        const segmentacionValida = validoReglasTipoPac &&validoReglasSubTipoPac;
        respuesta = respuestaValSeg && segmentacionValida;

        console.info("respuestaValSeg",respuestaValSeg,
            "validoReglasTipoPac", validoReglasTipoPac,
            "validoReglasSubTipoPac", validoReglasSubTipoPac,
            "segmentacionValida", segmentacionValida,
            "respuesta", respuesta);

        if(!respuesta){ // si en caso que la validacion de arriba sea arriba sea falso, coloco la promocion reestringida en true;
          promoTmp.promocionReestringida = true;
        }

      }
      return respuesta;
      /*if (tratAct != null) {//funcion aparte
        //console.info("TRATS+++++++++++++PROMO DE PLAN", tratAct.tratamiento, promoTmp.idPromocion, promoTmp.descuento, promoTmp.promocion+"%", tratAct, promoTmp, this.tratamiento);

        const planesPromo = promoTmp.aplicaEnPlanes.find(pln => pln.idPlan == tratAct.idPlan);//obtengo regla de promocion por plan
        if(planesPromo === undefined){
          promoTmp.promocionReestringida = true;
          return true;
        }
        if (planesPromo != null) {
          promoTmp.promocionReestringida = false;
          if (!this.validarSegmentacionPlan(tratAct.porcentajePlanDescuento, planesPromo.operadorReglaPorAplicacionPlan, planesPromo.valorReglaPorAplicacionPlan)) {
            const planesPromo2 = promoTmp.aplicaEnPlanes.find(pln => pln.idPromocion == tratAct.idPromocion);
            if(planesPromo2 != undefined && promoTmp.aplicaEnPlanes !== undefined){
              promoTmp.promocionReestringida = false;
              return false;
            }
            //console.info("TRATS+++++++++++++PROMO DE PLAN -- DESCUENTO NO CUMPLE", tratAct, planesPromo);
            promoTmp.promocionReestringida = true;
            return true;
          }
        } else {
          const lstPlanesPromoSeg = promoTmp.aplicaEnPlanes.filter(pln => pln.idPlan == null);//obtengo regla de promocion para segmentacion
          //console.info("TRATS+++++++++++++PROMO DE PLAN -- ", lstPlanesPromoSeg);
          for (let i=0; i < lstPlanesPromoSeg.length; i++) {
            //console.info("TRATS+++++++++++++PROMO DE PLAN 0 -- ", lstPlanesPromoSeg[i]);
            promoTmp.promocionReestringida = !this.validarSegmentacionPlan(tratAct.porcentajePlanDescuento,
                lstPlanesPromoSeg[i].operadorReglaPorAplicacionPlan, lstPlanesPromoSeg[i].valorReglaPorAplicacionPlan)
            if (!promoTmp.promocionReestringida) {
              //console.info("TRATS+++++++++++++PROMO DE PLAN -- DESCUENTO SI CUMPLE", lstPlanesPromoSeg[i], lstPlanesPromoSeg);
              return false;
            }
          }
          return true; // no hay ningun segmento que cumpla
        }//console.info("TRATS+++++++++++++PROMO DE PLAN -- SI CUMPLE");
      }*/
    },
    validarSegmentacionPlan(porcentajeDescuentoActualPlan, operador, valorRegla) {

      if (operador==null || valorRegla ==null) { //si es solo validacion por plan, que no valide las reglas, de lo contrario que valide los porcentajes de planes
        console.info("-------****validarSegmentacionPlan 01** OPERADOR O REGLA NULA", porcentajeDescuentoActualPlan, operador, valorRegla);
        return true;
      }

      let resultado = false;

      if (operador == "=") {
        resultado = porcentajeDescuentoActualPlan == valorRegla;
      } else if (operador == ">") {
        resultado = porcentajeDescuentoActualPlan > valorRegla;
      } else if (operador == "<") {
        resultado = porcentajeDescuentoActualPlan < valorRegla;
      } else if (operador == ">=") {
        resultado = porcentajeDescuentoActualPlan >= valorRegla;
      } else if (operador == "<=") {
        resultado = porcentajeDescuentoActualPlan <= valorRegla;
      }

      console.info("-------****validarSegmentacionPlan 02*** ", porcentajeDescuentoActualPlan, operador, valorRegla, resultado);
      return resultado;
    }
  },
  computed: {
    lista() {
      let promos = this.promociones.filter( value =>value.tratmientosDescuento.some( it => it['idTratamiento'] === this.tratamiento.idTratamiento))
      promos.forEach(p => {
        if(p.promocionForzosa){
          this.agregarPromocion(p);
          return null;
        } else {
          console.log("p--->",p)
          this.noAplicaPromoPlan(p); //se manda a validación para desactivar select
        }
      })
      return promos;
    },
  },
}
</script>

<style scoped>
.zoom {
  font-size: xx-large;
  transition: transform .2s; /* Animation */
  margin: 0 auto;
  color: red;
}
.zoom:hover {
  color: gray;
  transform: scale(1.5);
}
.bordePromo {
  min-height: 3em;
  margin-left: 0.5em;
  margin-right: 0.5em;
  border-bottom: 1px solid rgba(194, 194, 194, 0.36);
  display: flex;
  z-index: 10;
  position: relative;
  background: white;
  padding: 5px;
  min-width: 100px;
}
.centrado {
  text-align: left;
  align-items: center;
  margin-left: 0px ;
  margin-top: auto ;
  margin-bottom: auto ;
  vertical-align: center;
  padding: 0px !important;
}
.pulsate-fwd {
  -webkit-animation: pulsate-fwd 0.5s ease-in-out infinite both;
  animation: pulsate-fwd 0.5s ease-in-out infinite both;
}

/* ----------------------------------------------
 * Generated by Animista on 2022-2-21 13:11:57
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation pulsate-fwd
 * ----------------------------------------
 */
@-webkit-keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.esquina {
  position: absolute;
  top: 33%;
  right: 0%;
}

</style>
